export default __webpack_public_path__ + "static/media/qr-scanner.60ef5c1c.png";